/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.8",
    versionName: "0.2.0-nightly.2025.8.8",
    versionChannel: "nightly",
    buildDate: "2025-08-08T00:08:19.824Z",
    commitHash: "e8e0d671193d307bc032f437c8323d574ce737dc",
};
